import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import findLastIndex from 'lodash/findLastIndex';
import sortBy from 'lodash/sortBy';

import {VALUES_PROP_TYPE} from 'eventbrite_design_system/inputField/constants';

import DropdownTag from './DropdownTag';
import FilterLinks from './FilterLinks';

import {
    OTHER_EVENTBRITE_CATEGORY,
    EVENTBRITE_CATEGORY_MAPPING,
    DATES_MAPPING,
    PRICE_MAPPING,
    EVENTBRITE_FORMAT_MAPPING,
} from '../constants';

const TYPE_DISPLAY_VALUE_MAP = {
    format: EVENTBRITE_FORMAT_MAPPING,
    dates: DATES_MAPPING,
    tags: EVENTBRITE_CATEGORY_MAPPING,
    price: PRICE_MAPPING,
};

export default class Filter extends PureComponent {
    static propTypes = {
        type: PropTypes.string.isRequired,
        id: PropTypes.string,
        value: PropTypes.string,
        values: VALUES_PROP_TYPE,
        placeholder: PropTypes.string,
        label: PropTypes.string,
        handleSelect: PropTypes.func,
        shouldKeepStyle: PropTypes.bool,
        handleClear: PropTypes.func,
        isBotRequest: PropTypes.bool,
        locationSlug: PropTypes.string,
        isLoading: PropTypes.bool,
    }

    _handleSelect = (selectedItem) => {
        const {handleSelect, type} = this.props;

        if (handleSelect) {
            handleSelect(type, selectedItem);
        }
    }

    _handleClear = () => {
        const {handleClear, type} = this.props;

        if (handleClear) {
            handleClear(type);
        }
    }

    render() {
        const {
            type,
            placeholder,
            id,
            label,
            locationSlug,
            shouldKeepStyle,
            values,
            value,
            isBotRequest,
            shouldOrderValues,
            isLoading,
        } = this.props;

        const displayValue = (TYPE_DISPLAY_VALUE_MAP[type] && TYPE_DISPLAY_VALUE_MAP[type][value]) || value;

        let displayValues = values.slice(0);

        if (shouldOrderValues) {
            const otherIndex = findLastIndex(displayValues, {value: OTHER_EVENTBRITE_CATEGORY});

            // findLastIndex returns -1 when the condition doesn't match any element in the array.
            // We want to order it only when the condition has at least one match.
            if (otherIndex !== -1) {
                const [otherCategory] = displayValues.splice(otherIndex, 1);

                displayValues = sortBy(displayValues, 'display');
                displayValues.push(otherCategory);
            } else {
                displayValues = sortBy(displayValues, 'display');
            }
        }

        let component = (
            <DropdownTag
                placeholder={placeholder}
                id={id}
                label={label}
                values={displayValues}
                displayValue={displayValue}
                onChange={this._handleSelect}
                shouldKeepStyle={shouldKeepStyle}
                onClose={this._handleClear}
                isLoading={isLoading}
            />
        );

        if (isBotRequest) {
            component = (
                <FilterLinks
                    locationSlug={locationSlug}
                    values={displayValues}
                    type={type}
                />
            );
        }

        return component;
    }
}
